<template>
  <div class="picker" v-if="isLoaded">
    <commonPopup
      v-if="earlyMorningPopup.isOpen"
      @close="earlyMorningPopup.isOpen = false"
      :msg="earlyMorningPopup.popupMsg"
    />
    <datePicker
      v-model="selectedDate"
      valueType="format"
      format="YYYY-MM-DD"
      placeholder="날짜선택"
      :editable="false"
      :class="{ error: originTimeInvalid }"
      class="calendar pretandard"
      :disabled-date="disabledBeforeTodayAndAfter30days"
    />

    <vue-timepicker
      :class="{ error: originTimeInvalid }"
      hide-clear-button
      hide-disabled-items
      v-model="selectTime"
      placeholder="시간선택"
      format="a hh시 mm분"
      hour-label="시"
      minute-label="분"
      apm-label="오전/오후"
      am-text="오전"
      pm-text="오후"
      drop-direction="auto"
      input-width="100%"
      fixed-dropdown-button
      auto-scroll
      @open="isOpen = true"
      @close="handleDropdown"
      @change="updateUserOriginTime"
      :hour-range="getAvailableOriginPickupTime.hour"
      :minute-range="getAvailableOriginPickupTime.minute"
    >
      <template v-slot:dropdownButton>
        <img
          class="arrow-icon"
          :class="{ rotate: isOpen }"
          src="@/assets/img/arrow-down.png"
        />
      </template>
    </vue-timepicker>
  </div>
</template>
<script>
import timePicker from "@/components/common/TimePicker/layout.vue";
import datePicker from "vue2-datepicker";
import mixinPickupTime from "@/mixins/mixinPickupTime";
import mixinOrder from "@/mixins/mixinOrder";
import mixinOrderValidate from "@/mixins/mixinOrderValidate";
import VueTimepicker from "vue2-timepicker";
import commonPopup from "@/components/modal/commonPopup/layout.vue";
import dayjs from "dayjs";
export default {
  props: ["originTimeInvalid", "isPass"],
  mixins: [mixinPickupTime, mixinOrder, mixinOrderValidate],
  components: {
    timePicker,
    datePicker,
    VueTimepicker,
    commonPopup
  },
  data() {
    return {
      earlyMorningPopup: {
        isOpen: false,
        popupMsg: `새벽 시간을 선택하셨어요. </br> 정말 이 시간대로 주문하는게 맞으신가요?`
      },
      isOpen: false,
      minTime: new Date(),
      selectTime: {
        hh: "",
        mm: "",
        a: ""
      },
      selectedDate: null
    };
  },
  watch: {
    originTimeInvalid: {
      handler(val) {
        if (val) {
          this.handleUpdateNowTime();
          this.selectedDate = this.getAvailableOriginPickupTime.date.min;
          this.selectTime = {
            hh: this.convertTohh(this.getAvailableOriginPickupTime.hour[0]),
            mm: this.getAvailableOriginPickupTime.minute[0],
            a: ""
          };
          this.setApms(this.getAvailableOriginPickupTime.hour[0]);
          this.updateUserOriginTime();
        }
      }
    },
    selectedDate: {
      handler(newVal, oldVal) {
        this.updateUserOriginTime();
        if (oldVal !== null) {
          this.$emit("calculator");
        }
      }
    },
    "getAvailableOriginPickupTime.hour": {
      handler(val) {
        if (!val) return;
        if (!val.includes(this.convertToHH(this.selectTime.hh))) {
          if (this.selectTime.hh !== "") {
            this.selectTime.hh = this.convertTohh(val[0]);
            this.setApms(val[0]);
          }
        }
      },
      deep: true
    },
    "getAvailableOriginPickupTime.minute": {
      handler(val) {
        if (!val) return;
        if (this.selectTime.mm === "") {
          return;
        }
        if (!val.includes(this.selectTime.mm)) {
          this.selectTime.mm = val[0];
        }
      },
      deep: true
    }
  },

  methods: {
    handleDropdown() {
      this.isOpen = false;
      if (this.isEarlyMorningDelivery()) {
        this.earlyMorningPopup.isOpen = true;
      }
    },
    isEarlyMorningDelivery() {
      const time = dayjs()
        .hour(this.getPins[0].pickupHour)
        .minute(this.getPins[0].pickupMinute);

      const max = dayjs().set("hour", 6).set("minute", 1);

      return time.isBefore(max);
    },
    setApms(hour) {
      if (hour > 11) {
        this.selectTime.a = "pm";
      } else {
        this.selectTime.a = "am";
      }
    },

    convertToHH(hour) {
      const hh = parseInt(hour, 10);
      if (this.selectTime.a === "am" && hh === 12) {
        return "00";
      } else if (this.selectTime.a === "pm" && hh === 12) {
        return hour;
      } else if (this.selectTime.a === "pm") {
        return (hh + 12).toString();
      } else {
        return hour;
      }
    },
    convertTohh(hour) {
      const HH = parseInt(hour, 10);
      if (HH > 12) {
        return "0" + (HH - 12).toString();
      } else {
        return hour;
      }
    },
    changeHandler() {
      this.updateUserOriginTime();
    },

    //주문 가능한 날짜 +30일
    disabledBeforeTodayAndAfter30days(date) {
      return (
        dayjs(date).isBefore(this.getAvailableOriginPickupTime.date.min) ||
        dayjs(date).isAfter(this.getAvailableOriginPickupTime.date.max)
      );
    },

    //오늘날짜 이전인지 확인
    checkEditOrderTime() {
      return dayjs(this.getPins[0].pickupDate).isBefore(
        this.getAvailableOriginPickupTime.date.min,
        "day"
      );
    },

    //주문 가능한 가장 빠른 시간으로 초기 설정
    asap() {
      if (this.$route.params.flag === "update") {
        this.$emit("checkOriginTime");
        this.selectedDate = this.getPins[0].pickupDate;
        this.selectTime = {
          hh: this.convertTohh(this.getPins[0].pickupHour),
          mm: this.getPins[0].pickupMinute,
          a: ""
        };
        this.setApms(this.getPins[0].pickupHour);
        this.$emit("checkOriginTime");
      } else {
        this.selectedDate = this.getAvailableOriginPickupTime.date.min;

        this.selectTime = {
          hh: this.convertTohh(this.getAvailableOriginPickupTime.hour[0]),
          mm: this.getAvailableOriginPickupTime.minute[0],
          a: ""
        };
        this.setApms(this.getAvailableOriginPickupTime.hour[0]);
      }

      this.updateUserOriginTime();
      this.$emit("calculator");
    },

    updateUserOriginTime() {
      const origin =
        this.selectedDate && this.selectTime.hh
          ? dayjs(
              `${this.selectedDate} ${this.convertToHH(this.selectTime.hh)}:${
                this.selectTime.mm ?? "00"
              }:00`
            )
          : null;

      this.handleUpdatePickupTime({ origin: origin });
      if (this.selectedDate && this.selectTime.hh && this.selectTime.mm) {
        this.updatePickupTime(
          this.selectedDate,
          this.convertToHH(this.selectTime.hh),
          this.selectTime.mm
        );
      }

      this.$emit("calculator");
    }
  },
  created() {
    this.asap();
  }
};
</script>
<style scoped>
.picker {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
</style>
<style src="@/assets/css/newGlobal.css" scoped></style>
<style src="./calendar.css"></style>
<style src="./time.css"></style>
